import React from "react"
import './movie.css'

const img_list = [
    'https://cdn.img.tyhjrbl.com/img/202604/02/1114fLJROtxhyV.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1115QdHQIgfawq.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1115rb9UbH4fp0.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1115MTlOg6KCW6.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/11151u4vNdeypQ.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1115FSthsAa9QF.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1131qjP2d0xlaW.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1135PnSGPHR2LM.png',     
    'https://cdn.img.tyhjrbl.com/img/202604/02/1131hthtNgLHz2.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1131cg2ESrdoNP.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1131T7ULx0FPEc.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1132aBv3gvZ2d4.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1132zB2HxUmd4C.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1132u5wTUIesCN.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1132ytXorcYyBs.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1132RCPVyxnVTB.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1132gRG62Qqvy4.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1132ZETPcEHUSp.png',
]


export default function Movie () {
    return (
        <>
            <div className='mov_box'>
                <div className='one'>
                    {img_list.slice(0, 4).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                </div>
                <div className='two'>
                    {img_list.slice(4, 8).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                </div>
                <div className='three'>
                    {img_list.slice(8, 12).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                </div>
                <div className='four'>
                    {img_list.slice(12 , 15).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
                <div className='five'>
                    {img_list.slice(15 , 18).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
            </div>
        </>
    )
}